/* @flow weak */
import cx from 'classnames';
import React from 'react';

import AddButton from 'components/AddButton.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import PaymentSourceActions from 'payments/actions/PaymentSourceActions';
import PaymentSourceStore from 'payments/stores/PaymentSourceStore';

import AddPaymentSourceModal from './AddPaymentSourceModal.jsx';
import PaymentCardsManagerItem from './PaymentCardsManagerItem.jsx';
import { ManagerItemPlaceholderCard } from './ManagerItemCard.jsx';
import { mountModal } from 'lib/modal';

export default React.createClass({
  mixins: [
    linkStateWithStores([PaymentSourceStore]),
  ],

  getInitialState() {
    return Object.assign({ loading: true }, this.getStateFromStores());
  },

  componentDidMount() {
    PaymentSourceActions.load().then(
      () => this.setState({ loading: false }),
      () => this.setState({ loading: false }),
    );
  },

  getStateFromStores() {
    return {
      paymentSources: PaymentSourceStore.getPaymentSources(),
    };
  },

  shouldDisplayLoadingIndicator() {
    return (
      this.state.loading &&
      this.state.paymentSources.length <= 0
    );
  },

  renderCards() {
    return this.state.paymentSources.map(paymentSource => {
      return (
        <PaymentCardsManagerItem
          key={paymentSource.id}
          paymentSource={paymentSource}
        />
      );
    });
  },

  renderBody() {
    if (this.shouldDisplayLoadingIndicator()) {
      return <ManagerItemPlaceholderCard />;
    }

    return (
      <div>
        {this.state.paymentSources.length > 0 && this.renderCards()}
        <AddButton
          size="large"
          onClick={() => mountModal(<AddPaymentSourceModal />, this)}>
          Add a credit or debit card
        </AddButton>
      </div>
    );
  },

  render() {
    return (
      <div className={cx('PaymentCardsManager', this.props.className)}>
        {this.renderBody()}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/PaymentCardsManager.jsx